export type ProductStatusFilterValue = 'all' | 'active' | 'inactive';

export const PRODUCT_STATUS_OPTIONS = [
  { label: 'All', value: 'all' as const },
  { label: 'Active', value: 'active' as const },
  { label: 'Inactive', value: 'inactive' as const },
];

export function matchesProductStatusFilter(
  isActive: boolean | undefined,
  filter: ProductStatusFilterValue
): boolean {
  if (filter === 'all') return true;
  if (filter === 'active') return isActive !== false;
  return isActive === false;
}

export function filterByProductStatus<T extends { active?: boolean }>(
  data: T[],
  status: ProductStatusFilterValue
): T[] {
  if (status === 'all') return data;
  if (status === 'active') return data.filter((item) => item.active !== false);
  return data.filter((item) => item.active === false);
}

export function sortInactiveToBottom<T extends { active?: boolean }>(data: T[]): T[] {
  const active: T[] = [];
  const inactive: T[] = [];
  data.forEach((item) => {
    if (item.active === false) {
      inactive.push(item);
    } else {
      active.push(item);
    }
  });
  return [...active, ...inactive];
}

export function applyProductStatusFilter<T extends { active?: boolean }>(
  data: T[],
  status: ProductStatusFilterValue
): T[] {
  return filterByProductStatus(data, status);
}